// Ambiance sonore très douce générée par la Web Audio API — aucun fichier audio,
// aucune licence à gérer. Un accord grave et feutré qui "respire" lentement.
const KEY = "bizarre_ambient_v1";

export const ambientEnabled = () => {
  try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
};
export const setAmbientEnabled = (v) => {
  try { localStorage.setItem(KEY, v ? "1" : "0"); } catch {}
};

let ctx = null;
let master = null;

export function startAmbient() {
  if (ctx) return;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return;
  ctx = new AC();
  master = ctx.createGain();
  master.gain.value = 0;

  const filter = ctx.createBiquadFilter();
  filter.type = "lowpass";
  filter.frequency.value = 850;
  filter.connect(master);
  master.connect(ctx.destination);

  // Accord grave et doux (La — Do# — Mi)
  [110, 138.6, 164.8].forEach((f) => {
    const osc = ctx.createOscillator();
    osc.type = "sine";
    osc.frequency.value = f;
    const g = ctx.createGain();
    g.gain.value = 0.16;
    osc.connect(g); g.connect(filter);
    osc.start();
  });

  // Respiration lente
  const lfo = ctx.createOscillator();
  lfo.frequency.value = 0.07;
  const lfoGain = ctx.createGain();
  lfoGain.gain.value = 0.014;
  lfo.connect(lfoGain);
  lfoGain.connect(master.gain);
  lfo.start();

  master.gain.setTargetAtTime(0.05, ctx.currentTime, 2.5); // fondu d'entrée
}

export function stopAmbient() {
  if (!ctx) return;
  const closing = ctx;
  try { master.gain.setTargetAtTime(0, ctx.currentTime, 0.5); } catch {}
  setTimeout(() => { try { closing.close(); } catch {} }, 1000);
  ctx = null; master = null;
}
